import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  gap: 1px;
  border-bottom: 2px solid var(--rule-2);
  margin-bottom: 16px;
`;

export const TabButton = styled.button`
  padding: 6px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ $active }) => ($active ? "var(--accent)" : "var(--ink-3)")};
  border-bottom: 2px solid
    ${({ $active }) => ($active ? "var(--accent)" : "transparent")};
  margin-bottom: -2px;
  font-family: var(--font-sans);
  transition: color 0.15s, border-color 0.15s;
`;
